import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import Header from "./components/Header";
import Body from "./components/Body";
import Footer from "./components/Footer";
import { createBrowserRouter, RouterProvider, Outlet } from "react-router-dom";
import Contact from "./components/Contact";
import Error from "./components/Error";
import RestaurantMenu from "./components/RestaurantMenu";
import LoginForm from "./components/LoginForm.js";
import Profile from "./components/Profile";
import { lazy, Suspense, useState } from "react";
import UserContext from "./utils/UserContext";
import { Provider } from "react-redux";
import store from "./utils/store";
import Cart from "./components/Cart";
import SignUp from "./components/SignUp";
import { onAuthStateChanged } from "firebase/auth";
import {auth} from "./utils/firebase";

const Instamart = lazy(() => import("./components/Instamart"));
const About = lazy(() => import("./components/About"));
const Help = lazy(() => import("./components/Help"));

const AppLayout = () => {
  const [user, setUser] = useState({
    name: "",
    email: "",
  });

  const [userlocation, setUserlocation] = useState({
    lat: 26.218287,
    lng: 78.182831,
  });


  useEffect(() => {

    //setting current user if any
    onAuthStateChanged(auth, (user) => {
      if(user){
        let username = user.email.slice(0, user.email.indexOf("@"));
        username = username[0].toUpperCase() + username.slice(1).toLowerCase();
        setUser({ name: username, email: user.email });
        // console.log(user);
      }
      else{
        setUser({name: "", email: ""});
        // console.log("user logged out");
      }
    })
  }, []);

  return (
    <>
      <Provider store={store}>
          <UserContext.Provider value={{ user: user, setUser: setUser }}>
            {/*
          Header
              -Logo
              -NavItems
              -Cart
          Body
              -Search Bar
              -RestaurantList
                  -RestaurantCard
                      -Image
                      -Name
                      -Rating
                      -Cuisines

          Footer
              -links
              -copyright
          */}
            <div className="flex flex-col min-h-screen">
              <Header />
              <Outlet />
              <Footer />
            </div>
          </UserContext.Provider>
      </Provider>
    </>
  );
};

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    errorElement: <Error />,
    children: [
      {
        path: "/",
        element: <Body />,
      },
      {
        path: "/about",
        element: (
          <Suspense>
            <About />
          </Suspense>
        ),
        children: [
          {
            path: "profile",
            element: <Profile />,
          },
        ],
      },
      {
        path: "/contact",
        element: <Contact />,
      },
      {
        path: "/restaurant/:restaurantId",
        element: <RestaurantMenu />,
      },
      {
        path: "/login",
        element: <LoginForm />,
      },
      {
        path: "/instamart",
        element: (
          <Suspense>
            <Instamart />
          </Suspense>
        ),
      },
      {
        path: "/help",
        element: (
          <Suspense>
            <Help />
          </Suspense>
        ),
      },
      {
        path: "/cart",
        element: <Cart />,
      },
      {
        path: "/signUp",
        element: <SignUp/>
      }
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<RouterProvider router={appRouter} />);
root.render(<RouterProvider router={appRouter} />);
